import styled from 'styled-components'

import { helpers } from 'styles'

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: ${helpers.spacing.xxLarge};
`
